import { Link } from "react-router-dom";
import type { SiteSettings } from "@/lib/types";

/** Renders a link with React Router if internal, plain anchor if external/hash. */
function SmartLink({ href, className, children }: { href: string; className?: string; children: React.ReactNode }) {
  const isExternal = /^https?:\/\//.test(href) || href.startsWith("mailto:") || href.startsWith("tel:");
  const isHashOnly = href.startsWith("#");
  if (isExternal || isHashOnly) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}

export default function Nav({ settings }: { settings: SiteSettings }) {
  return (
    <nav className="nav" aria-label="Primary">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" aria-label={`${settings.siteName} home`}>
          <SteerLogo />
        </Link>

        <div className="nav-links">
          {settings.nav.map((item) => {
            if (item.dropdown) {
              return (
                <div className="nav-item" key={item.label}>
                  <a href="#" className="nav-link has-dropdown" onClick={(e) => e.preventDefault()}>
                    {item.label}
                  </a>
                  <div className="nav-dropdown">
                    {item.dropdown.map((d) => (
                      <SmartLink key={d.href + d.title} href={d.href}>
                        <span className="dropdown-title">{d.title}</span>
                        <span className="dropdown-sub">{d.sub}</span>
                      </SmartLink>
                    ))}
                  </div>
                </div>
              );
            }
            return (
              <SmartLink key={item.label} href={item.href ?? "#"} className="nav-link">
                {item.label}
              </SmartLink>
            );
          })}
        </div>

        <SmartLink href={settings.ctaHref} className="nav-cta">
          {settings.ctaLabel}
        </SmartLink>
      </div>
    </nav>
  );
}

/** Inline SVG logo — simple wordmark so we don't depend on a PNG asset being present. */
function SteerLogo() {
  return (
    <svg
      width="130"
      height="24"
      viewBox="0 0 130 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <text
        x="0"
        y="18"
        fontFamily="Fraunces, serif"
        fontWeight="500"
        fontSize="20"
        letterSpacing="-0.01em"
        fill="#ffffff"
      >
        Steer
      </text>
      <circle cx="60" cy="12" r="3" fill="#2DCFC1" />
      <text
        x="68"
        y="18"
        fontFamily="Geist, sans-serif"
        fontWeight="500"
        fontSize="13"
        letterSpacing="0.02em"
        fill="rgba(255,255,255,0.7)"
      >
        Health
      </text>
    </svg>
  );
}
